import React from 'react';
import { LocaleProvider as AntLocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import viVN from 'antd/lib/locale-provider/vi_VN';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

const LocaleProvider = ({ locale, ...props }) => (
  <AntLocaleProvider
    locale={locale === 'vi' ? viVN : enUS }
  >
    <IntlProvider locale={locale}>
      <div>
        {props.children}
      </div>
    </IntlProvider>
  </AntLocaleProvider>
);

export default connect(state => ({
  locale: state.intl.locale,
}))(LocaleProvider);



// WEBPACK FOOTER //
// ./src/locales/LocaleProvider.js